import React from "react";
import { I2cInput } from "@webcomponents/i2cwebcomponents/dist/react";

import "../../PrepaidComponents/Prepaid.scss";
import { Controller } from "react-hook-form";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
const NewProgamForm = ({ control, handleValueChanges, methods, errors }) => {
  return (
    <div className="forms-instance">
      <div i2c-grid="grid gap-sm">
        <div i2c-grid="12">
          <div className="sub-heading">New Program Projections</div>
          <div className="custom-label-light">
             First year projctions.
          </div>
        </div>
        <div i2c-grid="12">
          <div className="custom-label mb-6">
          Estimated Count{" "}
            <span className="light-color">(Number of cards to be migrated)</span>
            <sup>•</sup>
          </div>
          <div i2c-grid="grid gap-sm">
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_mig_np_ecount_1"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q1 estimate"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_mig_np_ecount_1"}
                      required
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.pi_mig_np_ecount_1 &&
                    methods.formState.touchedFields.pi_mig_np_ecount_1
                      ? true
                      : false
                  }
                  message={
                    errors.pi_mig_np_ecount_1?.message ?? "Invalid input"
                  }
                /> */}
              </div>
            </div>
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_mig_np_ecount_2"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q2 estimate"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_mig_np_ecount_2"}
                      required
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.pi_mig_np_ecount_2 &&
                    methods.formState.touchedFields.pi_mig_np_ecount_2
                      ? true
                      : false
                  }
                  message={
                    errors.pi_mig_np_ecount_2?.message ?? "Invalid input"
                  }
                /> */}
              </div>
            </div>
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_mig_np_ecount_3"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q3 estimate"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_mig_np_ecount_3"}
                      required
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.pi_mig_np_ecount_3 &&
                    methods.formState.touchedFields.pi_mig_np_ecount_3
                      ? true
                      : false
                  }
                  message={
                    errors.pi_mig_np_ecount_3?.message ?? "Invalid input"
                  }
                /> */}
              </div>
            </div>
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_mig_np_ecount_4"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q4 estimate"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_mig_np_ecount_4"}
                      required
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.pi_mig_np_ecount_4 &&
                    methods.formState.touchedFields.pi_mig_np_ecount_4
                      ? true
                      : false
                  }
                  message={
                    errors.pi_mig_np_ecount_4?.message ?? "Invalid input"
                  }
                /> */}
              </div>
            </div>
          </div>
        </div>
        <div i2c-grid="12">
          <div className="custom-label mb-6">
          Estimated Value{" "}
            <span className="light-color">(Estimated transaction value)</span>
            <sup>•</sup>
          </div>
          <div i2c-grid="grid gap-sm">
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_mig_np_evalue_1"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q1 estimate"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_mig_np_evalue_1"}
                      required
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.pi_mig_np_evalue_1 &&
                    methods.formState.touchedFields.pi_mig_np_evalue_1
                      ? true
                      : false
                  }
                  message={
                    errors.pi_mig_np_evalue_1?.message ?? "Invalid input"
                  }
                /> */}
              </div>
            </div>
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_mig_np_evalue_2"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q2 estimate"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_mig_np_evalue_2"}
                      required
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.pi_mig_np_evalue_2 &&
                    methods.formState.touchedFields.pi_mig_np_evalue_2
                      ? true
                      : false
                  }
                  message={
                    errors.pi_mig_np_evalue_2?.message ?? "Invalid input"
                  }
                /> */}
              </div>
            </div>
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_mig_np_evalue_3"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q3 estimate"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_mig_np_evalue_3"}
                      required
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.pi_mig_np_evalue_3 &&
                    methods.formState.touchedFields.pi_mig_np_evalue_3
                      ? true
                      : false
                  }
                  message={
                    errors.pi_mig_np_evalue_3?.message ?? "Invalid input"
                  }
                /> */}
              </div>
            </div>
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_mig_np_evalue_4"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q4 estimate"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_mig_np_evalue_4"}
                      required
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.pi_mig_np_evalue_4 &&
                    methods.formState.touchedFields.pi_mig_np_evalue_4
                      ? true
                      : false
                  }
                  message={
                    errors.pi_mig_np_evalue_4?.message ?? "Invalid input"
                  }
                /> */}
              </div>
            </div>
          </div>
        </div>
        <div i2c-grid="12">
          <div className="custom-label mb-6">
          Estimated  Volume{" "}
            <span className="light-color">(Estimated transaction volume)</span>
            <sup>•</sup>
          </div>
          <div i2c-grid="grid gap-sm">
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_mig_np_evolume_1"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q1 estimate"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_mig_np_evolume_1"}
                      required
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.pi_mig_np_evolume_1 &&
                    methods.formState.touchedFields.pi_mig_np_evolume_1
                      ? true
                      : false
                  }
                  message={
                    errors.pi_mig_np_evolume_1?.message ?? "Invalid input"
                  }
                /> */}
              </div>
            </div>
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_mig_np_evolume_2"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q2 estimate"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_mig_np_evolume_2"}
                      required
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.pi_mig_np_evolume_2 &&
                    methods.formState.touchedFields.pi_mig_np_evolume_2
                      ? true
                      : false
                  }
                  message={
                    errors.pi_mig_np_evolume_2?.message ?? "Invalid input"
                  }
                /> */}
              </div>
            </div>
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_mig_np_evolume_3"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q3 estimate"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_mig_np_evolume_3"}
                      required
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.pi_mig_np_evolume_3 &&
                    methods.formState.touchedFields.pi_mig_np_evolume_3
                      ? true
                      : false
                  }
                  message={
                    errors.pi_mig_np_evolume_3?.message ?? "Invalid input"
                  }
                /> */}
              </div>
            </div>
            <div i2c-grid="6@sm 3@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_mig_np_evolume_4"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Q4 estimate"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_mig_np_evolume_4"}
                      required
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.pi_mig_np_evolume_4 &&
                    methods.formState.touchedFields.pi_mig_np_evolume_4
                      ? true
                      : false
                  }
                  message={
                    errors.pi_mig_np_evolume_4?.message ?? "Invalid input"
                  }
                /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewProgamForm;
